import { useSuspenseQuery } from "@tanstack/react-query"
import { createFileRoute } from "@tanstack/react-router"
import { Box, Button, Flex, Text } from "@ui"
import type { FC } from "react"

import { solutionSettingsQuery } from "../-shared/solutionSettings.query"
import { queryClient } from "../../../queryClient"
import { ApiTokensList } from "./-components/ApiTokensList"
import { CreateApiTokenModal } from "./-components/CreateApiTokenModal"

const ApiTokensPage: FC = () => {
  const { data: solutionSettings } = useSuspenseQuery(solutionSettingsQuery)

  return (
    <Flex
      flexDirection="column"
      gap="lg"
      padding="lg"
      width="full"
      alignSelf="flex-start"
    >
      <Flex
        justifyContent="space-between"
        alignItems="center"
      >
        <Box>
          <Text textStyle="pageTitle">API Tokens</Text>
          <Text textStyle="description">
            Create API token to use inside Contact Centre in order to connect
            Agent Co-Pilot
          </Text>
        </Box>
        <Button
          variant="primary"
          onClick={() => {
            CreateApiTokenModal.open({})
          }}
        >
          Create token
        </Button>
      </Flex>
      <ApiTokensList tokens={solutionSettings.tokens} />
    </Flex>
  )
}

export const Route = createFileRoute("/_authenticated/api-tokens/")({
  loader: () => {
    return queryClient.ensureQueryData(solutionSettingsQuery)
  },
  component: ApiTokensPage,
})
